import BaseComponent from '../../components/base-component/base-component'

class RecentlyViewed extends BaseComponent {
  containers: HTMLElement[]
  currVisibleProductCount: number

  cardLimit: number

  constructor() {
    super()

    this.containers = [
      ...this.querySelectorAll('[recently-viewed-container]'),
    ] as HTMLElement[]

    this.cardLimit = +this.dataset.cardLimit

    this.currVisibleProductCount = 0

    this.sectionSettings = JSON.parse(this.dataset.sectionSettings)
  }

  connectedCallback(): void {
    this.setItems()
  }

  setItems(): void {
    const productsFromStorage = localStorage.getItem(
      'AuroraTheme-RecentlyProducts',
    )

    const data = JSON.parse(productsFromStorage)

    if (!data) {
      return
    }

    const products = this.createProducts(data)

    this.containers.forEach(container => {
      container.innerHTML = products
    })
  }

  static updateProductsInLocalStorage(template: string, handle: string): void {
    if (!template || !handle) {
      return
    }

    const currentSavedProducts = localStorage.getItem(
      'AuroraTheme-RecentlyProducts',
    )
    const products = { [handle]: template, ...JSON.parse(currentSavedProducts) }
    const productKeys = Object.keys(products)

    const limitedProductKeys = productKeys.slice(0, 50)
    const limitedProducts = limitedProductKeys.reduce((acc, productKey) => {
      return { ...acc, [productKey]: products[productKey] }
    }, {})

    localStorage.setItem(
      'AuroraTheme-RecentlyProducts',
      JSON.stringify(limitedProducts),
    )
  }

  createProducts(products: object): string {
    let result = ''

    const productsHandlers = Object.keys(products)

    productsHandlers.reverse().forEach(productHandle => {
      const template = this.prepareTemplate(products[productHandle])
      const productNode = this.createNodeByString(template)

      if (this.sectionSettings.product_card_align === 'center') {
        productNode.classList.add('product-card--center-alignment')
      }

      const isLimitAchieved = this.currVisibleProductCount >= this.cardLimit
      const isDisplayedProduct = productHandle === this.dataset.productHandle

      if (isLimitAchieved) {
        return
      }

      if (isDisplayedProduct) {
        return
      }

      result = `${result} ${productNode.outerHTML}`

      this.visibleProductCount += 1
    })

    return result
  }

  prepareTemplate(template: string): string {
    return template.replaceAll(
      /shape--square|shape--landscape|shape--portrait-xl|shape--portrait/gi,
      `shape--${this.sectionSettings.img_ratio}`,
    )
    // .replaceAll(/class="card-carousel__slide"/gi, '')
  }

  createNodeByString(productString: string): HTMLElement {
    return new DOMParser()
      .parseFromString(productString, 'text/html')
      .querySelector('[recently-viewed-item]')
  }

  setVisible(isVisible: boolean): void {
    this.classList.toggle('hidden', !isVisible)
  }

  set visibleProductCount(value: number) {
    const hasVisibleProducts = value > 0

    this.currVisibleProductCount = value

    this.setVisible(hasVisibleProducts)
  }

  get visibleProductCount(): number {
    return this.currVisibleProductCount
  }
}

export default RecentlyViewed
